import React from 'react'
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
const DayViewAvailabilityPlaceholderChip = ({event}) => {

    return (
      <li className={classNames(`relative flex col-start-${event.column} cursor-pointer -z-50`)} key={event.id} style={{ gridRow: `${event.rowNumber}/ ${event.rowNumber + event.rowLength}`}}>
          <div className={classNames(`border-solid opacity-70 border-2 ${event.color.borderColor200} group absolute inset-x-1 inset-y-0 inset flex flex-col overflow-y-auto rounded-lg px-2 pt-1 text-xs hover:shadow-xl border-2 border-solid ${event.color.borderColor500} transition-shadow duration-300 leading-5`)}
          >
            <p className={`font-bold text-base m-0 ${event.color.textColor500}`}>{event.name}</p>
            <p className={`${event.color.textColor500} m-0 inline w-12 group-hover:${event.color.textColor500}`}>
              <time dateTime={event.time}>{event.time}</time>
            </p>
            <p className={`m-0 inline w-12 ml-14 -mt-5 ${event.color.textColor500}`}>{event.lessonLength} min</p>
          </div>
      </li> 
    )
}
export default DayViewAvailabilityPlaceholderChip